import { useMemo } from "react";
import { Map } from "leaflet";
import { Navigate, useParams } from "react-router-dom";

import { useConfigParameters } from "hooks/configParametersHooks";
import { useMeasureConfigs } from "hooks/measureConfigHooks";
import { useStudyArea } from "hooks/studyAreaHooks";
import { useSelectedMeasure } from "hooks/measureHooks";

import { MeasureImpact, MeasureConf } from "types/types";

import { AddMeasureConfigsDrawerContent } from "components/drawerContent/AddMeasureConfigsDrawerContent";

interface Props {
  mapRef: Map;
  footerRef: HTMLDivElement;
  uuid: string;
}

export function AddMeasureConfigGuard(props: Props) {
  const { mapRef, footerRef, uuid } = props;
  const { data: studyArea } = useStudyArea(uuid);
  const { data: measureConfigs } = useMeasureConfigs(uuid);
  const { data: config } = useConfigParameters();
  const { groupId } = useParams();

  const selectedMeasure = useSelectedMeasure(
    studyArea?.measureImpactList || []
  );
  const isReadOnly = !!studyArea?.readOnly;

  const measureConfigId = useMemo(() => {
    const urlMeasureConfigId = parseInt(groupId || "");
    if (
      urlMeasureConfigId !== undefined &&
      urlMeasureConfigId !== null &&
      !isNaN(urlMeasureConfigId)
    )
      return urlMeasureConfigId;
    return Date.now() + Math.random();
  }, [groupId]);

  function updateMeasureConfigs(
    measureConfigs: MeasureConf[],
    measureConfigId: number,
    selectedMeasure: MeasureImpact
  ) {
    const doesMeasureConfigExist =
      measureConfigs.findIndex(
        (measureConfig) => measureConfig.id === measureConfigId
      ) > -1;


    if (doesMeasureConfigExist) return measureConfigs;

    const newMeasureConfig: MeasureConf = {
      id: measureConfigId,
      measure: selectedMeasure.measure,
      layers: [],
      propertyValueList: [],
    };

    return [...measureConfigs, newMeasureConfig];
  }

  return (
    <>
      {(!selectedMeasure || isReadOnly) && (
        <Navigate to={`/${uuid}/measures`} />
      )}
      {studyArea && measureConfigs && config && selectedMeasure && (
        <AddMeasureConfigsDrawerContent
          mapRef={mapRef}
          footerRef={footerRef}
          uuid={uuid}
          studyArea={studyArea}
          config={config}
          measureConfigId={measureConfigId}
          selectedMeasure={selectedMeasure}
          isHardenedSurface={selectedMeasure.measure.hardenedSurface}
          isNewMeasureConfig={!groupId}
          backendMeasureConfigs={updateMeasureConfigs(
            measureConfigs,
            measureConfigId,
            selectedMeasure
          )}
        />
      )}
    </>
  );
}
